import React from 'react';
import './App.css';
import TranslatorApp from './components/TranslatorApp';

function App() {
  return (
    <div className="App">
      <TranslatorApp />
    </div>
  );
}

export default App;
